import { render, staticRenderFns } from "./valores_variables.vue?vue&type=template&id=78583ed9&"
import script from "./valores_variables.vue?vue&type=script&lang=ts&"
export * from "./valores_variables.vue?vue&type=script&lang=ts&"
import style0 from "./valores_variables.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports